import { ArticleOutlined as ArticleOutlinedIcon } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import ProviderTermsAndConditionsDialog from "./ProviderTermsAndConditionsDialog";

interface ProviderTermsAndConditionsIconButtonProps {
  readonly onClick: () => void;
}

const ProviderTermsAndConditionsIconButton: FC<ProviderTermsAndConditionsIconButtonProps> = ({ onClick }) => (
  <Tooltip title="Regulamin dostawcy">
    <IconButton aria-label="Regulamin dostawcy" onClick={onClick} size="small">
      <ArticleOutlinedIcon />
    </IconButton>
  </Tooltip>
);

interface Props {
  readonly providerId: string | undefined;
}

const ProviderTermsAndConditions: FC<Props> = ({ providerId }) => {
  const [open, setOpen] = useState(false);

  if (!providerId) {
    return null;
  }

  return (
    <>
      <ProviderTermsAndConditionsIconButton onClick={() => setOpen(true)} />
      <ProviderTermsAndConditionsDialog open={open} providerId={providerId} onClose={() => setOpen(false)} />
    </>
  );
};

export default ProviderTermsAndConditions;
